(function() {
  var observedCards = new WeakSet();

  function applyStyles(card) {
    if (!card.shadowRoot) return;

    // Host-Element selbst auf 100% Breite zwingen
    card.style.setProperty('display', 'block', 'important');
    card.style.setProperty('width', '100%', 'important');

    card.shadowRoot.querySelectorAll('.bg-button').forEach(function(btn) {
      btn.style.setProperty('background-color', '#000', 'important');
      btn.style.setProperty('width', '100%', 'important');

      var parent = btn.parentElement;
      if (parent) {
        parent.style.setProperty('width', '100%', 'important');
      }
    });
  }

  function observeCard(card) {
    if (observedCards.has(card) || !card.shadowRoot) return;
    observedCards.add(card);
    applyStyles(card);
    new MutationObserver(function() {
      applyStyles(card);
    }).observe(card.shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  function scanAndObserve() {
    document.querySelectorAll('spark-product-card').forEach(function(card) {
      if (card.shadowRoot) {
        observeCard(card);
      } else {
        setTimeout(function() { observeCard(card); }, 100);
        setTimeout(function() { observeCard(card); }, 500);
        setTimeout(function() { observeCard(card); }, 1500);
      }
    });
  }

  scanAndObserve();

  new MutationObserver(scanAndObserve).observe(document.body, {
    childList: true,
    subtree: true
  });

  var attempts = 0;
  var interval = setInterval(function() {
    scanAndObserve();
    attempts++;
    if (attempts >= 25) clearInterval(interval);
  }, 200);
})();